// extracted by mini-css-extract-plugin
export default {"pageWrapper":"GameWrapper_pageWrapper__Dbs25","pageContainer":"GameWrapper_pageContainer__5fjv3"};